import React, {useEffect, useContext} from 'react'
import {
  Checkbox,
  FormControlLabel,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Typography,
  ListSubheader,
} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import {ReservationConfigurationContext} from '../../../context/ReservationConfiguration'
import {useParams} from 'react-router'

const FDisplayValueField = ({data, onChange = (e, key, value) => {}}) => {
  let displayFieldOptions = []
  const {additionalFieldValues, getAdditionalFieldValues} = useContext(
    ReservationConfigurationContext
  )
  const {group_id} = useParams()
  useEffect(() => {
    getAdditionalFieldValues(group_id, ['all'], true, false, false)
  }, [group_id, getAdditionalFieldValues])

  const getDisplayFieldValueOptions = () => {
    let output = []
    additionalFieldValues.data?.data?.fields &&
      !Array.isArray(additionalFieldValues.data?.data?.fields) &&
      Object.keys(additionalFieldValues.data?.data?.fields).map(opt => {
        output.push(<ListSubheader value={opt}>{`${opt} `}</ListSubheader>)

        let x = additionalFieldValues.data?.data?.fields[opt].map(f => {
          output.push(<MenuItem value={f[1]}>{`${f[0]}`}</MenuItem>)
        })
        return true
      })
    return output
  }
  return (
    <>
      <FormControl variant="outlined" className="ap-textfield" style={{width: 200, marginTop: 16}}>
        <InputLabel id="">Display Field</InputLabel>
        <Select
          labelId=""
          id=""
          label="Display Field"
          value={data?.display_field_value}
          onChange={(e, value) => onChange(e, 'display_field_value')}
          style={{width: '200px'}}
        >
          {getDisplayFieldValueOptions()}
        </Select>
      </FormControl>
      <Typography>
        This field will not be displayed on group action / group return on field types referenced
        from multiple group list types.
      </Typography>
      <br />
      <FormControlLabel
        style={{marginBottom: 0}}
        control={
          <Checkbox
            onClick={e =>
              onChange(e, 'display_after_action', !(data?.display_after_action || false))
            }
            size="small"
            checkedIcon={<CheckCircleIcon style={{color: '#3473ff'}} />}
            checked={data?.display_after_action || false}
            name="required"
          />
        }
        label="Display Value After Action Performed"
      />
    </>
  )
}

export default FDisplayValueField
